export default "__VITE_ASSET__NgjunDmv__"